import React from "react";
import { PieChart } from "@mui/x-charts/PieChart";
import "./Donut.css";
import { useDrawingArea } from "@mui/x-charts/hooks";
import { styled } from "@mui/material/styles";

const StyledText = styled("text")(({ theme }) => ({
  fontSize: 15,
  fontWeight: 600,
  fill: theme.palette.text.primary,
  textAnchor: "middle",
  dominantBaseline: "central",
}));

const Donut = ({
  data,
  isTotal = false,
  total = 0,
  title,
  height = 200,
  width = 400,
  widthContainer = "40%",
  heightContainer = "50%",
  innerRadius = 60,
  outerRadius = 80,
  colors,
  showLabelWithX = false,
}) => {
  // Validar que data sea un array y no esté vacío
  const isValidData = Array.isArray(data) && data.length > 0;

  // Preparar los datos para el gráfico
  const prepareData = () => {
    if (!isValidData) return [];
    return data.map((item, index) => ({
      id: `${item.x}-${item.label || index}`,
      value: item.y || 0,
      label: showLabelWithX
        ? `${item.label || ""} (${item.x}) (${item.y})`
        : item.label || item.x || `Item ${index + 1}`,
      color: colors && colors[index % colors.length],
    }));
  };

  function getTotalValue(data) {
    console.log("total", total);
    return isTotal ? total : data.reduce((total, item) => total + item.y, 0);
  }

  function PieCenterLabel({ children }) {
    const { width, height } = useDrawingArea();
    // Ajustamos la posición para centrar perfectamente
    return (
      <StyledText
        x="49%"
        y="50%"
        textAnchor="middle"
        dominantBaseline="central"
      >
        {children}
      </StyledText>
    );
  }

  return (
    <div
      className="donut-chart-container"
      style={{ height: heightContainer, width: widthContainer }}
    >
      {title && <h3 className="chart-title">{title}</h3>}
      <div className="chart-wrapper">
        {isValidData ? (
          <PieChart
            series={[
              {
                data: prepareData(),
                innerRadius: innerRadius,
                outerRadius: outerRadius,
                paddingAngle: 0,
                cornerRadius: 2,
                startAngle: -90,
                endAngle: 270,
                cx: 190,
                cy: 80,
              },
            ]}
            height={height}
            width={width}
            margin={{
              left: 5,
              right: 5,
              top: 5,
              bottom: 5,
            }}
            slotProps={{
              legend: {
                direction: "column",
                position: { vertical: "bottom", horizontal: "left" },
                padding: 10,
              },
              tooltip: {
                sx: {
                  color: "#000",
                  borderRadius: "8px",
                  padding: "8px 12px",
                  fontSize: "14px",
                  fontWeight: 500,
                },
              },
            }}
          >
            <PieCenterLabel>{getTotalValue(data)}</PieCenterLabel>
          </PieChart>
        ) : (
          <div className="no-data-message">No data available</div>
        )}
      </div>
    </div>
  );
};

export default Donut;
